import { tenantSettings } from "utils/authentication/tenantSettings";
import { PERMISSIONS } from "utils/constants";
import { UserContext_userContext } from "utils/graphql/UserContext";

export const showNotificationLink = (
  userContext: UserContext_userContext,
  notificationCount: number,
  newNotificationCount: number,
  isSurveyCompleted: boolean,
  isClearNotification: boolean
) => {
  return (
    userContext &&
    ((notificationCount && notificationCount > 0) ||
      (newNotificationCount && newNotificationCount > 0) ||
      (userContext.showSurvey && !isSurveyCompleted)) &&
    !isClearNotification
  );
};

export const showReportLink = (userContext: UserContext_userContext) => {
  return (
    userContext?.permissions &&
    userContext.permissions.length > 0 &&
    userContext.permissions.includes(PERMISSIONS.CAN_VIEW_REPORT)
  );
};

export const showServiceNowLink = (userContext: UserContext_userContext) => {
  return (
    tenantSettings?.customConfig?.serviceNowUrl &&
    userContext?.permissions &&
    userContext.permissions.length > 0 &&
    userContext.permissions.includes(PERMISSIONS.CAN_VIEW_REPORT)
  );
};

export const showAttendanceLink = (userContext: UserContext_userContext) => {
  return (
    userContext?.permissions &&
    userContext.permissions.length > 0 &&
    userContext.permissions.includes(PERMISSIONS.CAN_MANAGE_ATTENDANCE)
  );
};
